import { Button } from "@at/design-system-elements";
import {
  ThemeSelectors,
  TypePhantom,
  TypeFiesta,
} from "@at/design-system-foundation";
import styled, { css } from "styled-components";

import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

export const ExpertReviewContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)};
  @media (min-width: 900px) {
    flex-direction: row;
    margin-top: ${({ theme }) => ThemeSelectors.getDistinctTwoSpacing(theme)};
  }
`;
export const ExpertReviewMediaContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  @media (min-width: 900px) {
    flex: 1;
    margin-bottom: 0;
  }
`;
export const ExpertReviewVideoContainer = styled.div`
  width: 100%;
  flex: 1 1 auto;
  @media (min-width: 900px) {
    background: black;
    position: relative;
  }
`;
export const ExpertReviewImageContainer = styled.div`
  width: 100%;
  flex: 1 1 auto;
  padding-bottom: 56.25%;
  overflow: hidden;
  height: 0;
  @media (min-width: 900px) {
    background: black;
    position: relative;
  }
`;
export const ExpertReviewImage = styled.img`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => ThemeSelectors.getGrey(theme)};
  ${PrintStyleSheet}
  @media (min-width: 900px) {
    aspect-ratio: 16 / 9;
  }
`;
export const ExpertReviewTextContent = styled.div<{ $noMediaContent: boolean }>`
  text-align: left;
  display: flex;
  flex-direction: column;
  @media (min-width: 900px) {
    flex: 1;
    padding-left: ${({ theme }) => ThemeSelectors.getDistinctOneSpacing(theme)};
    ${({ $noMediaContent }) => {
      if ($noMediaContent)
        return css`
          padding-left: 0;
        `;
    }}
  }
`;
export const ExpertReviewHeading = styled(TypePhantom)`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  font-variation-settings: "wght" 400;
  @media (min-width: 600px) {
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  }
`;
export const ExpertReviewRatingBlock = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  @media (min-width: 600px) {
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  }
`;
export const ExpertReviewIntroText = styled(TypeFiesta)`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  text-align: left;
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  a {
    text-decoration: none;
  }
  @media (min-width: 900px) {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
export const ExpertReviewOverallRatingBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)};
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  color: ${({ theme }) => ThemeSelectors.getWhite(theme)};
`;
export const ExpertReviewButton = styled(Button)`
  width: 100%;
  margin-top: auto;
  @media (min-width: 450px) {
    max-width: 60%;
  }
`;
